import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import axios from "axios";
import Button from "react-bootstrap/Button";
import "../style/Login.css";
import useForm from "./Validations/useForm";
import Logo from "../assets/logoMDSS.png";
import { validEmail, validPassword } from "../components/Regex";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Login({ setToken }) {
  const [emailErr, setEmailErr] = useState(false);
  const [pwdError, setPwdError] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    document.body.style.overflow = "hidden";
    let loginCheck = localStorage.getItem("login");
    if (loginCheck) {
      navigate("/");
    }
  });

  const submit = async (values) => {
    console.log(values);
    const response = await axios.post(
      "http://172.17.85.23:8081/login",
      { email: values.email, password: values.password },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    console.log(response);

    if (response.data == "UserNotFound") {
      // alert("User Not Found");
      toast.error("User Not Found");
      setTimeout(() => {
        window.location.reload(true);
      }, 2200);
    } else if (response.data == "CheckCredentials") {
      toast.error("Check Credentials");
      setTimeout(() => {
        window.location.reload(true);
      }, 2200);
      // alert("Check Credentials");
    } else {
      localStorage.setItem("login", true);
      localStorage.setItem("user", response.data.email);
      toast.success("Login Successful");
      // alert("Login Successful");
      navigate("/");
    }
  };
  const { state, handleChange, handleSubmit } = useForm(submit); // add validation func, initState as argum

  return (
    <div
      className="container"
      style={{
        backgroundColor: "#135571",
        marginTop: "8%"
      }}
    >
      <center>
        <img src={Logo} size={30} />
      </center>
      {/* <h4 className="heading">Login</h4> */}
      <Card bg="transparent">
        <form onSubmit={handleSubmit} noValidate>
          <div className="form-container">
            <LoginInput
              state={state}
              handleChange={handleChange}
              name="email"
              label="E-mail"
            />
            <LoginInput
              state={state}
              handleChange={handleChange}
              name="password"
              label="Password"
            />
            <center style={{ marginLeft: "45%" }}>
              <Button className="mt-4" variant="outline-light" type="submit">
                Log In
              </Button>
            </center>
          </div>
        </form>
        <center>
          <Link to="/signup" style={{ fontSize: 15, color: "#fff" }}>
            Signup
          </Link>
        </center>
      </Card>

      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

const LoginInput = ({ name, label, state, handleChange }) => {
  // const {state, handleChange} = useContext(LoginContext);
  return (
    <label>
      {label}
      <input
        type={name}
        placeholder={name}
        name={name}
        value={state.input[name]}
        onChange={handleChange}
      />
      <span className="validation-errors">{state.validationErrs[name]}</span>
    </label>
  );
};
